
export const getErrorLogColumns = (isAllUser) => {
    const errorLogColumns = [
        {
            title: 'pid',
            dataIndex: 'pid',
            key: 'pid',
        },
        {
            title: '로그시간',
            dataIndex: 'created',
            key: 'created',
            width: 200,
        },
        {
            title: 'errorData',
            dataIndex: 'errorData',
            key: 'errorData',
            align: 'left',
        },

    ]

    return isAllUser
        ? errorLogColumns
        : errorLogColumns.filter(col =>
            col.dataIndex === 'errorData' || col.dataIndex === 'created'
        );
}